import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReferralStorageService } from '@/services/referral/ReferralStorageService';
import { toast } from '@/hooks/use-toast';
import Landing from './Landing';

/**
 * Wrapper component for the Landing page that handles referral codes from query parameters
 * This allows URLs like https://thematmonster.com/?ref=ABC123 to work properly
 */
const LandingWrapper = () => {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('ref');
  const campaign = searchParams.get('campaign');

  useEffect(() => {
    if (referralCode) {

      
      try {
        // Store the referral code for later use during signup
        const success = ReferralStorageService.storeReferralCode(referralCode, campaign || undefined);
        
        if (success) {

          
          // Show toast notification to user
          toast({
            title: "Referral applied",
            description: "You'll receive 30% off when you sign up!",
          });
        } else {
          console.error('Failed to store referral code from landing page');
        }
      } catch (error) {
        console.error('Error storing referral code from landing page:', error);
      }
    }
  }, [referralCode, campaign]);

  // Pass referral information to the Landing component
  return (
    <Landing 
      isReferral={!!referralCode} 
      referralCode={referralCode || undefined} 
    />
  );
};

export default LandingWrapper;
